"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _Portal = _interopRequireDefault(require("../Portal"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

var _run = _interopRequireDefault(require("../icons/run.svg"));

var _pause = _interopRequireDefault(require("../icons/pause.svg"));

require("./videoModal.sass");

var _ref = _react.default.createElement("div", {
  className: "modal-video-icon-circle"
}, _react.default.createElement(_run.default, {
  className: "modal-video-icon modal-video-icon--play"
}));

var _ref2 = _react.default.createElement("div", {
  className: "modal-video-icon-circle"
}, _react.default.createElement(_pause.default, {
  className: "modal-video-icon"
}));

var _ref3 = _react.default.createElement(_Spinner.default, null);

var VideoModal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(VideoModal, _PureComponent);

  function VideoModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, VideoModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(VideoModal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onPlaying", function () {
      _this.unmounted || _this.setState({
        playing: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onPause", function () {
      _this.unmounted || _this.setState({
        playing: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onReady", function () {
      _this.unmounted || _this.setState({
        ready: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "togglePlay", function () {
      var video = _this.refs.video;

      if (video) {
        video.paused ? video.play() : video.pause();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(VideoModal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounted = true;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
          video = _this$props.video,
          onClose = _this$props.onClose;
      var _this$state = this.state,
          ready = _this$state.ready,
          playing = _this$state.playing; // as not all platfroms support h.264 in mp4 we want to provide webm source first

      var sortWeight = function sortWeight(type) {
        return type === 'webm' ? -1 : 0;
      };

      var sources = video && Object.keys(video).sort(function (a, b) {
        return sortWeight(a) - sortWeight(b);
      }).map(function (type) {
        return _react.default.createElement("source", {
          key: type,
          src: video[type],
          type: 'video/' + type
        });
      });
      return _react.default.createElement("div", {
        className: "modal-video"
      }, ready && _react.default.createElement("a", {
        className: "modal-close modal-close--circle",
        onClick: onClose
      }, "\xD7"), ready && playing && _ref, ready && !playing && _ref2, !ready && _ref3, _react.default.createElement("video", {
        className: (0, _classnames.default)('modal-video-src', {
          'modal-video-src--hidden': !ready
        }),
        autoPlay: true,
        loop: true,
        ref: "video",
        onClick: this.togglePlay,
        onPause: this.onPause,
        onLoadedData: this.onReady,
        onPlaying: this.onPlaying
      }, sources));
    }
  }, {
    key: "render",
    value: function render() {
      var onClose = this.props.onClose;
      return _react.default.createElement(_Portal.default, null, _react.default.createElement(_Modal.default, {
        onClose: onClose,
        className: "modal--video"
      }, this.renderContent()));
    }
  }]);
  return VideoModal;
}(_react.PureComponent);

exports.default = VideoModal;